import type { DiagramLabelPosition, DiagramLinkData } from './diagram.types';
import { DiagramLabel } from './DiagramLabel';
import type { TextDimensions } from '#hooks/PRIVATE_useTextDimensions';
import { layerStyles } from './themes/DiagramStyles.css';
import { useUser } from '#hooks/UNSAFE_useUser';

type Props<K1, K2, D2 extends DiagramLinkData<K2, K1>> = {
  labelPosition: Map<K2, DiagramLabelPosition>;
  itemProps: D2[];
  labelDimensions: Map<K2, TextDimensions>;
};

export function DiagramLabelLayer<K1, K2, D2 extends DiagramLinkData<K2, K1>>({
  labelPosition,
  itemProps,
  labelDimensions
}: Props<K1, K2, D2>) {
  const { direction } = useUser();
  return (
    <div class={layerStyles}>
      {itemProps.map((item) => {
        if (item.label && labelPosition.get(item.id)) {
          return (
            <DiagramLabel
              styles={item.labelStyle}
              text={item.label}
              position={labelPosition.get(item.id)!}
              dimensions={labelDimensions.get(item.id)!}
              isRTL={direction === 'rtl'}
            />
          );
        }
        return undefined;
      })}
    </div>
  );
}
